import { render, staticRenderFns } from "./MyDataModal.vue?vue&type=template&id=21ce40a9&lang=pug&"
import script from "./MyDataModal.vue?vue&type=script&lang=js&"
export * from "./MyDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MyDataModal.vue"
export default component.exports